export default {
  'proTech.proEquip': 'Equipos de producción',
  'proTech.chiselIntroduce': 'Introducción a brasing rod',
  'proTech.testingInstrument': 'Instrumento de ensayo',
  'proTech.techProcess': 'Proceso tecnológico'
}
